import {Avatar, Select, SelectItem} from "@heroui/react";
import {useAppSelector} from "../../../hooks/redux";
import {Country} from "../../../types";

export default function LanguageSelector ({ defaultValue, onChange } : { defaultValue?: Set<string>, onChange: (val: Country[]) => void }) {

    const { countries, loading } = useAppSelector(state => state.session)

    return (
        <Select variant={'bordered'} defaultSelectedKeys={defaultValue} selectionMode="multiple" isLoading={loading.countries} label="Lingue dell'annuncio" isVirtualized={true} onChange={event => {
            const values = event.target.value.split(',')
            onChange(countries.filter(c => {
                return values.includes(c.idCountry.toString())
            }))
        }}>
            {
                countries.map((country, index) => (
                    <SelectItem
                        key={index}
                        startContent={
                            <Avatar alt={country.countryName} className="w-6 h-6" src={`https://flagcdn.com/${country.countryAlpha2.toLowerCase()}.svg`} />
                        }
                    >
                        {country.countryName}
                    </SelectItem>
                ))
            }
        </Select>
    )

}
